// ============================================================
// format.js — money/date helpers, parse user input → cents
// ============================================================

export function fmtCents(cents, opts = {}) {
  if (cents == null) return opts.dash ? '-' : '$0.00';
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents) / 100;
  const formatted = abs.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return sign + formatted;
}

// Parse user input "$1,234.56" / "1234.56" / "-50" → integer cents.
export function parseAmountToCents(s) {
  if (s == null) return null;
  let str = String(s).trim();
  if (!str) return null;
  let neg = false;
  if (str.startsWith('(') && str.endsWith(')')) { neg = true; str = str.slice(1, -1); }
  if (str.startsWith('-')) { neg = true; str = str.slice(1); }
  str = str.replace(/[$,\s]/g, '');
  if (!str) return null;
  const n = parseFloat(str);
  if (Number.isNaN(n)) return null;
  const cents = Math.round(n * 100);
  return neg ? -cents : cents;
}

// 'YYYY-MM-DD' → 'May 1, 2026'
export function fmtDate(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// 'YYYY-MM-DD' → 'Fri May 1'
export function fmtDateShort(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export function todayIso() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(new Date());
}

export function addDaysIso(iso, days) {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().slice(0, 10);
}
